import React from 'react';

import FoundItLowerButton from '../../../../../../components/found-it-lower-button/found-it-lower-button';
import ProductQuantity from '../../../../../../components/product-quantity/product-quantity';
import ProductSetDescription from '../../../../../../components/product-set-description/product-set-description';
import ProductSetImage from '../../../../../../components/product-set-image/product-set-image';
import ProductListCardPrice from '../../../product-list-card-price/product-list-card-price';

import { isWindShieldWiperProduct } from '../../../../../../shared/utils/product/product';

import { ProductData } from '../../../../../../shared/types/graphql-types';

import './product-list-set-card-position.scss';

interface ProductListSetCardPositionProps {
  index: number;
  onQuantityChange: (quantity: number, index: number) => void;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListSetCardPosition(props: ProductListSetCardPositionProps) {
  const { index, onQuantityChange, product, quantity, totalQuantity } = props;
  const isWindShieldWiper = isWindShieldWiperProduct(product);
  function handleQuantityChange(_, updatedValue) {
    onQuantityChange(updatedValue, index);
  }

  return (
    <div styleName="container">
      <ProductSetImage product={product} />
      <div styleName="product-details">
        <ProductSetDescription product={product} />
        <div styleName="price-qty-container">
          <div styleName="price-container">
            <ProductListCardPrice
              product={product}
              quantity={quantity}
              totalQuantity={totalQuantity}
            />
            <FoundItLowerButton
              productItem={{
                product: product,
                quantity: quantity,
                totalQuantity: totalQuantity
              }}
            />
          </div>

          <ProductQuantity
            defaultValue={isWindShieldWiper ? 1 : 2}
            id="quantity"
            onBlur={handleQuantityChange}
            onChange={handleQuantityChange}
            showLabel
            value={quantity}
          />
        </div>
      </div>
    </div>
  );
}

export default ProductListSetCardPosition;
